import { Component, OnInit, Inject } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-prioridad-por-sintoma',
  templateUrl: './prioridad-por-sintoma.component.html',
  styleUrls: ['./prioridad-por-sintoma.component.scss']
})
export class PrioridadPorSintomaComponent implements OnInit {

  public consecutivo;
  public usuario;
  public prioridad:FormControl;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private servicios: ServiciosService) { }

  ngOnInit() {
    this.consecutivo = this.datos.csc;
    this.usuario = this.datos.usuario;
    this.prioridad = new FormControl();
    console.log(this.consecutivo);
    this.servicios.getPrioridadPorSintoma(this.consecutivo).subscribe(([data]:any)=>{
        this.prioridad.setValue(data.prioridadPorSintoma);
        console.log(this.prioridad.value);
    })
  }

  enviar(){
    this.servicios.prioridadPorSintoma(this.usuario,this.consecutivo, this.prioridad).subscribe((data)=>{
      console.log(data);
    })
  }

}
